import React, { memo, useCallback, useMemo } from 'react'
import { Form, Formik } from 'formik'
import type { InsurancePolicy } from 'src/interfaces/insurancePolicy'
import { InsurancePolicyFormContent } from './InsurancePolicyFormContent'
import { insurancePolicyFormValidator } from './InsurancePolicyForm.validator'
import type { InsurancePolicyFormValues } from './InsurancePolicyForm.interface'

interface Props {
  formId: string
  policy: InsurancePolicy | null
  onSubmit(values: InsurancePolicyFormValues): void
}

const InsurancePolicyFormComponent = ({ formId, policy, onSubmit }: Props) => {
  const initialValues = useMemo<InsurancePolicyFormValues>(() => {
    return {
      name: policy?.name ?? '',
    }
  }, [policy])

  const handleSubmit = useCallback(
    (values: InsurancePolicyFormValues) => {
      onSubmit(values)
    },
    [onSubmit],
  )

  return (
    <Formik<InsurancePolicyFormValues>
      initialValues={initialValues}
      validationSchema={insurancePolicyFormValidator}
      // Reopening the modal on a different row must reseed the field.
      enableReinitialize
      onSubmit={handleSubmit}
    >
      <Form id={formId}>
        <InsurancePolicyFormContent />
      </Form>
    </Formik>
  )
}

export const InsurancePolicyForm = memo(InsurancePolicyFormComponent)
